module.exports = __webpack_public_path__ + "media/src/application/media/v2-img-5-fb1f3a47c2b019810734883ceb00ef8e.jpg";